import pkg from './package.json';

export const { version } = pkg;
export * from './src/utils';
